import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "memberCenter-coupon_primary",
  "use": "memberCenter-coupon_primary-usage",
  "viewBox": "0 0 100 220",
  "content": "<symbol viewBox=\"0 0 100 220\" xmlns=\"http://www.w3.org/2000/svg\" id=\"memberCenter-coupon_primary\"><path d=\"M0 124.937C0 116.688 6.68772 110 14.9374 110H85.0626C93.3123 110 100 116.688 100 124.937V220H0V124.937Z\" /><path d=\"M0 204C0 201.791 1.79086 200 4 200H96C98.2091 200 100 201.791 100 204V220H0V204Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol